/**
 * Firebase service shim (web).
 *
 * Vendored mobile services call `Firebase.functions.httpsCallable(name)`,
 * `Firebase.analytics.logEvent(...)` and `Firebase.auth.currentUser` (React
 * Native Firebase's shapes). This module exposes the same surface on the JS SDK
 * so those files vendor verbatim.
 */
import { httpsCallable } from 'firebase/functions';
import { serverTimestamp, deleteField, arrayUnion, arrayRemove } from 'firebase/firestore';
import { auth, db, functions, storage } from '@/lib/firebase';
import { track } from '@/lib/analytics';

export const Firebase = {
  auth,
  firestore: db,
  storage,
  functions: {
    httpsCallable: <Req = unknown, Res = unknown>(name: string) => httpsCallable<Req, Res>(functions, name),
  },
  analytics: {
    logEvent: async (name: string, params?: Record<string, unknown>): Promise<void> => {
      track(name, params);
    },
  },
};

/** RN-Firebase-shaped `firestore.FieldValue` for screens ported from mobile. */
export const FieldValue = {
  serverTimestamp,
  delete: deleteField,
  arrayUnion,
  arrayRemove,
};

export const initializeFirebase = async () => {};
